// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CartAddedPopup_overlay__FnYHD {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: CartAddedPopup_fadeIn__PUCiL 0.2s ease;
  padding: 1rem;
}

.CartAddedPopup_card__viQ6H {
  background: #fff;
  border-radius: 24px;
  padding: 2.5rem 2rem 2rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  animation: CartAddedPopup_popIn__c\\+Ibq 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.CartAddedPopup_iconCircle__Zv0cT {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(22, 163, 74, 0.18));
  color: #16a34a;
  animation: CartAddedPopup_checkPop__Rq0wT 0.4s 0.15s ease both;
}

.CartAddedPopup_title__WKNbn {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.3;
}

.CartAddedPopup_typeBadge__hKmZb {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6366f1;
  background: rgba(99, 102, 241, 0.08);
  padding: 0.35rem 0.9rem;
  border-radius: 20px;
}

.CartAddedPopup_itemLabel__Pr4wW {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #ff7a00;
  background: linear-gradient(135deg, rgba(255, 122, 0, 0.08), rgba(249, 115, 22, 0.08));
  padding: 0.55rem 1.25rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 122, 0, 0.15);
}

.CartAddedPopup_detailsBox__r22ab {
  width: 100%;
  background: #f9fafb;
  border-radius: 14px;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  border: 1px solid #f0f0f0;
}

.CartAddedPopup_detailRow__uCKJ- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
}

.CartAddedPopup_detailRow__uCKJ-:not(:last-child) {
  border-bottom: 1px solid #eee;
  padding-bottom: 0.4rem;
}

.CartAddedPopup_detailKey__SOZUd {
  font-size: 0.82rem;
  color: #888;
  font-weight: 500;
}

.CartAddedPopup_detailValue__PhC05 {
  font-size: 0.88rem;
  color: #1a1a1a;
  font-weight: 600;
}

.CartAddedPopup_buttons__n7wtM {
  display: flex;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.35rem;
}

.CartAddedPopup_okBtn__OP\\+Ip {
  flex: 1 1;
  padding: 0.85rem;
  border: none;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  background: linear-gradient(135deg, #ff7a00, #f97316);
  color: #fff;
  box-shadow: 0 4px 16px rgba(255, 122, 0, 0.3);
}

.CartAddedPopup_okBtn__OP\\+Ip:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 24px rgba(255, 122, 0, 0.35);
}

.CartAddedPopup_viewCartBtn__nEtc6 {
  flex: 1 1;
  padding: 0.85rem;
  border: 2px solid #ff7a00;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  background: transparent;
  color: #ff7a00;
}

.CartAddedPopup_viewCartBtn__nEtc6:hover {
  background: rgba(255, 122, 0, 0.06);
  transform: translateY(-2px);
}

@keyframes CartAddedPopup_fadeIn__PUCiL {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes CartAddedPopup_popIn__c\\+Ibq {
  from {
    opacity: 0;
    transform: scale(0.85) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes CartAddedPopup_checkPop__Rq0wT {
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.15);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CartAddedPopup.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,iDAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,8EAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qFAAqF;EACrF,cAAc;EACd,8DAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sFAAsF;EACtF,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,qDAAqD;EACrD,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;EAC9E,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: fadeIn 0.2s ease;\n  padding: 1rem;\n}\n\n.card {\n  background: #fff;\n  border-radius: 24px;\n  padding: 2.5rem 2rem 2rem;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);\n  animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.iconCircle {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(22, 163, 74, 0.18));\n  color: #16a34a;\n  animation: checkPop 0.4s 0.15s ease both;\n}\n\n.title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: #1a1a1a;\n  line-height: 1.3;\n}\n\n.typeBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6366f1;\n  background: rgba(99, 102, 241, 0.08);\n  padding: 0.35rem 0.9rem;\n  border-radius: 20px;\n}\n\n.itemLabel {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #ff7a00;\n  background: linear-gradient(135deg, rgba(255, 122, 0, 0.08), rgba(249, 115, 22, 0.08));\n  padding: 0.55rem 1.25rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 122, 0, 0.15);\n}\n\n.detailsBox {\n  width: 100%;\n  background: #f9fafb;\n  border-radius: 14px;\n  padding: 0.75rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  border: 1px solid #f0f0f0;\n}\n\n.detailRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25rem 0;\n}\n\n.detailRow:not(:last-child) {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 0.4rem;\n}\n\n.detailKey {\n  font-size: 0.82rem;\n  color: #888;\n  font-weight: 500;\n}\n\n.detailValue {\n  font-size: 0.88rem;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.buttons {\n  display: flex;\n  gap: 0.75rem;\n  width: 100%;\n  margin-top: 0.35rem;\n}\n\n.okBtn {\n  flex: 1;\n  padding: 0.85rem;\n  border: none;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  background: linear-gradient(135deg, #ff7a00, #f97316);\n  color: #fff;\n  box-shadow: 0 4px 16px rgba(255, 122, 0, 0.3);\n}\n\n.okBtn:hover {\n  transform: translateY(-2px) scale(1.02);\n  box-shadow: 0 8px 24px rgba(255, 122, 0, 0.35);\n}\n\n.viewCartBtn {\n  flex: 1;\n  padding: 0.85rem;\n  border: 2px solid #ff7a00;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n  background: transparent;\n  color: #ff7a00;\n}\n\n.viewCartBtn:hover {\n  background: rgba(255, 122, 0, 0.06);\n  transform: translateY(-2px);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes checkPop {\n  from {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CartAddedPopup_overlay__FnYHD`,
	"fadeIn": `CartAddedPopup_fadeIn__PUCiL`,
	"card": `CartAddedPopup_card__viQ6H`,
	"popIn": `CartAddedPopup_popIn__c+Ibq`,
	"iconCircle": `CartAddedPopup_iconCircle__Zv0cT`,
	"checkPop": `CartAddedPopup_checkPop__Rq0wT`,
	"title": `CartAddedPopup_title__WKNbn`,
	"typeBadge": `CartAddedPopup_typeBadge__hKmZb`,
	"itemLabel": `CartAddedPopup_itemLabel__Pr4wW`,
	"detailsBox": `CartAddedPopup_detailsBox__r22ab`,
	"detailRow": `CartAddedPopup_detailRow__uCKJ-`,
	"detailKey": `CartAddedPopup_detailKey__SOZUd`,
	"detailValue": `CartAddedPopup_detailValue__PhC05`,
	"buttons": `CartAddedPopup_buttons__n7wtM`,
	"okBtn": `CartAddedPopup_okBtn__OP+Ip`,
	"viewCartBtn": `CartAddedPopup_viewCartBtn__nEtc6`
};
export default ___CSS_LOADER_EXPORT___;
